import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { S25IconComponent } from "../s25-icon/s25.icon.component";
import { S25EventPreferencesComponent } from "./s25-event-preferences/s25.event.preferences.component";
import { OccSliderComponent } from "./s25-event-occurrences/occ-slider/occ-slider.component";
import { S25EventColanderComponent } from "./s25-event-colander/s25-event-colander.component";
import { S25MultiselectModule } from "../s25-multiselect/s25-multiselect.module";
import { S25LoadingInlineModule } from "../s25-loading/s25.loading.inline.module";
import { S25EditableModule } from "../s25-editable/s25.editable.module";
import { S25CheckboxModule } from "../s25-checkbox/s25.checkbox.module";
import { S25RadioModule } from "../s25-radio/s25.radio.module";
import { PopoverModule } from "../s25-popover/popover.module";
import { S25ModalModule } from "../s25-modal/s25.modal.module";
import { S25ItemModule } from "../s25-item/s25.item.module";
import { S25IconButtonComponent } from "../../standalone/s25.icon.button.component";

@NgModule({
    declarations: [S25EventPreferencesComponent, OccSliderComponent],
    providers: [S25EventPreferencesComponent, OccSliderComponent, S25EventColanderComponent],
    imports: [
        CommonModule,
        FormsModule,
        S25MultiselectModule,
        S25LoadingInlineModule,
        S25EditableModule,
        S25IconComponent,
        S25CheckboxModule,
        S25RadioModule,
        PopoverModule,
        S25ModalModule,
        S25ItemModule,
        S25IconButtonComponent,
        S25EventColanderComponent,
    ],
    exports: [S25EventPreferencesComponent, OccSliderComponent, S25EventColanderComponent],
})
export class S25EventDetailsModule {}
